import { useSelector } from "react-redux";
import reduxModule from "./redux";

export const useAccount = () => {
  const state = useSelector((state) => state.Account);

  return {
    // callback : (data, response) => {}
    signup: (params, callback = null) => reduxModule.signup(params, callback),
    pwChange: (params, callback = null) =>
      reduxModule.pwChange(params, callback),
    login: (id, pw, callback = null) => reduxModule.login(id, pw, callback),
    tokenCheck: (callback = null) => reduxModule.tokenCheck(callback),
    logout: (callback = null) => reduxModule.logout(callback),
    withdraw: (callback = null) => reduxModule.withdraw(callback),

    update: (params, callback = null) => reduxModule.update(params, callback),
    reset: (params, callback = null) => reduxModule.reset(params, callback),

    resetTokenCheck: () => reduxModule.resetTokenCheck(),

    cleanLoginResponse: () => reduxModule.cleanLoginResponse(),
    cleanSignUpResponse: () => reduxModule.cleanSignUpResponse(),

    state: state,

    signupResponse: state?.SignUp,
    loginResponse: state?.Login,
    tokenCheckResponse: state?.TokenCheck,
    logoutResponse: state?.Logout,

    updateResponse: state?.Update,

    withdrawResponse: state?.Withdraw,

    isTokenChecked: reduxModule.isTokenChecked,
    user: state?.user,
  };
};
